import { render, staticRenderFns } from "./ed-section-material-object.vue?vue&type=template&id=434716a6&scoped=true&"
import script from "./ed-section-material-object.ts?vue&type=script&lang=ts&"
export * from "./ed-section-material-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-material-object.scss?vue&type=style&index=0&id=434716a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434716a6",
  null
  
)

export default component.exports